export default __webpack_public_path__ + "static/media/warning--tractors--g5.c35fe753.png";